// components/MainContentWrapper.tsx
import styled from 'styled-components';

interface MainContentWrapperProps {
  $maxWidth?: string;
  padding?: string;
  children: React.ReactNode;
  className?: string;
}

const StyledMainContentWrapper = styled.div<MainContentWrapperProps>`
  flex-grow: 1;
  width: 100%;
  padding: ${({ padding }) => padding || ''};
  margin: 0 auto;
  max-width: ${({ $maxWidth }) => $maxWidth || '1600px'};
  height: 100%;
  & > div:first-child {
    padding: 1rem;
  }
`;

export const MainContentWrapper = ({ children, $maxWidth, padding, className }: MainContentWrapperProps) => {
  return (
    <StyledMainContentWrapper $maxWidth={$maxWidth} padding={padding} className={className}>
      {children}
    </StyledMainContentWrapper>
  );
};
